import { render } from "./ContainerComp.vue?vue&type=template&id=266b4f51"
import script from "./ContainerComp.vue?vue&type=script&lang=js"
export * from "./ContainerComp.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/SPINcrs-demo/SPINcrs-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__